import SubscribedSubscriptionState from 'redux/subscribedSubscription/interfaces/subscribedSubscriptionState';

const INIT_SUBSCRIBED_SUBSCRIPTION: SubscribedSubscriptionState = {
  subscription: null,
  isLoading: true,
};

export default INIT_SUBSCRIBED_SUBSCRIPTION;
